/**
 * Guardians stats API — ``/api/v1/guardiansv2/stats``.
 */

import { apiRequest } from "../client";
import type {
  AlertStats,
  CatalogueStat,
  IssueStat,
  OverviewStats,
  StatsFilterParams,
  TrendResponse,
} from "./types";

const BASE = "/guardiansv2/stats";

function statsParams(params: StatsFilterParams = {}) {
  const out: Record<string, string> = {};
  if (params.time_period) out.time_period = params.time_period;
  if (params.catalogue_key) out.catalogue_key = params.catalogue_key;
  if (params.mission_id) out.mission_id = params.mission_id;
  if (params.task_id) out.task_id = params.task_id;
  return out;
}

export async function getStatsOverview(
  params: StatsFilterParams = {},
  signal?: AbortSignal
): Promise<OverviewStats> {
  return apiRequest({
    method: "GET",
    url: `${BASE}/overview`,
    params: statsParams(params),
    signal,
  });
}

export async function getStatsByCatalogue(
  params: StatsFilterParams = {},
  signal?: AbortSignal
): Promise<CatalogueStat[]> {
  return apiRequest({
    method: "GET",
    url: `${BASE}/by-catalogue`,
    params: statsParams(params),
    signal,
  });
}

export async function getStatsIssues(
  params: StatsFilterParams = {},
  signal?: AbortSignal
): Promise<IssueStat[]> {
  return apiRequest({
    method: "GET",
    url: `${BASE}/issues`,
    params: statsParams(params),
    signal,
  });
}

export async function getStatsTrend(
  params: StatsFilterParams = {},
  signal?: AbortSignal
): Promise<TrendResponse> {
  return apiRequest({
    method: "GET",
    url: `${BASE}/trend`,
    params: statsParams(params),
    signal,
  });
}

export async function getStatsAlerts(
  params: StatsFilterParams = {},
  signal?: AbortSignal
): Promise<AlertStats> {
  return apiRequest({
    method: "GET",
    url: `${BASE}/alerts`,
    params: statsParams(params),
    signal,
  });
}
